import _ from "lodash";

const { sendSocketMessage } = require("./socketStream");
import store from "../store";

let instance = null;

class RemoteDebugTool {
    constructor() {
        this.debug = false;
    }

    /**
     *
     * @return {RemoteDebugTool}
     */
    static create() {
        if (!instance) {
            instance = new RemoteDebugTool();
        }
        return instance;
    }

    async runCommand(siteId, messageId, command, payload) {
        console.log("RemoteDebugTool.runCommand", { siteId, messageId, command, payload });
        switch (command) {
            case RemoteDebugTool.CommandTypes.AGENT_READ_VUEX:
                await this.readStore(siteId, command, messageId, payload.path);
                break;
            case RemoteDebugTool.CommandTypes.AGENT_IS_CONNECTED:
                sendSocketMessage("debug agent-response", {
                    siteId,
                    command,
                    messageId,
                    success: true,
                    data: {
                        connected: true,
                        userId: store.state?.auth?.user?._id,
                        name: store.state?.auth?.user?.name,
                    },
                    error: undefined,
                });

                break;
            case RemoteDebugTool.CommandTypes.AGENT_SS:
                await this.screenShot(siteId, command, messageId);
                break;

            default:
                sendSocketMessage("debug agent-response", {
                    siteId,
                    command,
                    messageId,
                    success: false,
                    data: undefined,
                    error: {
                        message: "Invalid command",
                    },
                });

                break;
        }
    }

    async readStore(siteId, command, messageId, path) {
        const data = _.get(store.state, path);
        sendSocketMessage("debug agent-response", {
            siteId,
            command,
            messageId,
            success: true,
            data: {
                userId: store.state?.auth?.user?._id,
                name: store.state?.auth?.user?.name,
                data,
            },
            error: undefined,
        });
    }

    async screenShot(siteId, command, messageId) {
        const html2canvas = require("html2canvas");
        const el = window.document.documentElement;
        html2canvas(el, {
            // scrollX: 0,
            // scrollY: 2000,
            // windowWidth: el.offsetWidth,
            // windowHeight: el.offsetHeight,
            // width: el.clientWidth,
            // height: el.clientHeight,
        }).then(function (canvas) {
            const screenshot = canvas.toDataURL("image/png");
            sendSocketMessage("debug agent-response", {
                siteId,
                command,
                messageId,
                success: true,
                data: {
                    screenshot,
                    userId: store.state?.auth?.user?._id,
                    name: store.state?.auth?.user?.name,
                },
                error: undefined,
            });
        });
    }
}

RemoteDebugTool.CommandTypes = {
    AGENT_READ_VUEX: "AGENT_READ_VUEX",
    AGENT_IS_CONNECTED: "AGENT_IS_CONNECTED",
    AGENT_SS: "AGENT_SS",
};

export default RemoteDebugTool;
